import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const getListSalesOrderStatus = (async(searchString,orderByString,pageNumber,pageSize) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.browse,
    method: 'get',
    params:{
        OrderByString:orderByString,
        SearchString:searchString,
        PageNumber: pageNumber,
        PageSize: pageSize
    }
}).then((res) =>{
    return res.data
}).catch((err) =>{
    return Promise.reject(err);
})

)

export const getSalesOrderStatus = (async (Id) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.load,
    method: 'get',
    params: {Id : Id}
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)


export const postSalesOrderStatusApi = (data) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.browse,
    method: "post",
    data:data,
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

export const putSalesOrderStatusApi = (data) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.browse,
    method: "put",
    data:data,
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


export const getSalesOrderStatusDictionary = (async () => await http({
    baseURL:INVENTORYANDSALES_URL,
    url:ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.dictionary,
    method: 'get',

})
    .then((response) => (response.data))

)


export const deleteListSalesOrderStatus = (id) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting.SalesOrderStatus.browse,
    method: 'delete',
    params:{
        id:id
    }
    
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
});